/**
 * File: apps/qbench-cp/reactapp/src/shared/layout/PortalTopNav/index.js
 *
 * Purpose: Renders the sticky top navigation bar for authenticated portal pages, switching
 *     between mobile and desktop layouts.
 *
 * Scope: Portal top navigation for the authenticated customer portal.
 *
 * Tags: customer-portal
 *
 * Overview: Renders nothing (an empty NavBarWrapper) when the user is not authenticated.
 *     When authenticated, on mobile it renders the Logo, a Search input, and BurgerMenu; on
 *     desktop it renders the Logo and MainMenu. isAuth and customPortalLogo come from app
 *     state, and isMobile comes from useResponsive.
 *
 * Exports: PortalTopNav component (default export).
 */

import { useAppStore } from 'App/store';
import React from 'react';
import Logo from './Logo/Logo';
import useResponsive from 'shared/hooks/misc/useResponsive';
import Search from 'shared/components/Search/Search';
import MainMenu from '../MainMenu';
import { DesktopMenu, MobileMenu, StyledNavBar, NavBarWrapper } from './Styles';
import BurgerMenu from 'shared/layout/PortalTopNav/BurgerMenu/BurgerMenu';

const PortalTopNav = (props) => {
  const {
    appState: { isAuth, customPortalLogo },
  } = useAppStore();

  const { isMobile } = useResponsive();

  return (
    <StyledNavBar>
      <NavBarWrapper isAuth={isAuth}>
        {isAuth && (
          <React.Fragment>
            {isMobile ? (
              <MobileMenu>
                <Logo isMobile customPortalLogo={customPortalLogo} />
                <Search />
                <BurgerMenu />
              </MobileMenu>
            ) : (
              <DesktopMenu>
                <Logo customPortalLogo={customPortalLogo} />
                <MainMenu />
              </DesktopMenu>
            )}
          </React.Fragment>
        )}
      </NavBarWrapper>
    </StyledNavBar>
  );
};

export default PortalTopNav;
